<template>
  <div class="page-tab account-adjust-container">
    <el-form ref="formRef" :model="form" :rules="rules" label-position="right" label-width="90px" size="small">
      <el-form-item label="会员账号">
        <el-input v-model="memberAccount" disabled class="input-small"></el-input>
      </el-form-item>
      <el-form-item label="钱包余额">
        <div class="wallet-balance-row">
          <el-input v-model="walletBalanceDisplay" disabled class="input-small"></el-input>
          <el-button
            type="primary"
            icon="el-icon-refresh"
            circle
            size="small"
            :loading="balanceLoading"
            @click="refreshWalletBalance"
          ></el-button>
        </div>
      </el-form-item>
      <el-form-item label="调整类型" prop="change_type">
        <el-radio-group v-model="form.change_type">
          <el-radio :label="1">系统调整</el-radio>
          <el-radio :label="2">输赢调整</el-radio>
        </el-radio-group>
        <div class="form-tip">系统调整上下分不影响代理佣金计算 / 输赢调整则会影响代理佣金计算</div>
      </el-form-item>
      <el-form-item label="调整方式" prop="adjust_method">
        <el-radio-group v-model="form.adjust_method">
          <el-radio label="up">上分</el-radio>
          <el-radio label="down">下分</el-radio>
        </el-radio-group>
      </el-form-item>
      <template v-if="form.adjust_method === 'up'">
        <el-form-item label="打码限制" prop="need_lock">
          <el-radio-group v-model="form.need_lock">
            <el-radio :label="2">无需打码限制</el-radio>
            <el-radio :label="1">需要打码限制</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-show="form.need_lock === 1" label="打码倍数" prop="multiple">
          <el-input-number
            v-model="form.multiple"
            :min="1"
            :controls="false"
            placeholder="正整数"
            class="input-small"
          ></el-input-number>
          <span class="suffix">倍</span>
        </el-form-item>
      </template>
      <el-form-item label="调整金额" prop="gold_yuan">
        <el-input-number
          v-model="form.gold_yuan"
          :precision="2"
          :min="0"
          :controls="false"
          placeholder="最多两位小数"
          class="input-small"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="备注" prop="desc">
        <el-input
          v-model="form.desc"
          type="textarea"
          :rows="3"
          maxlength="100"
          show-word-limit
          placeholder="不超过100字"
          class="textarea-small"
        ></el-input>
      </el-form-item>
      <el-form-item label="上传图片" prop="image_url">
        <el-upload
          class="avatar-uploader"
          action="#"
          :show-file-list="false"
          :on-change="handleImageChange"
          :before-upload="beforeUpload"
          :auto-upload="false"
        >
          <el-image v-if="form.image_url" :src="form.image_url" fit="cover" class="upload-preview"></el-image>
          <div v-else class="upload-placeholder">
            <i class="el-icon-plus"></i>
            <span>上传图片</span>
          </div>
        </el-upload>
        <div class="upload-tip">支持 jpg、jpeg、png，不超过 5M</div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" :loading="submitLoading" @click="handleSubmit">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { setAccountAdjust } from '@/api/user'
import { uploadToS3 } from '@/api/upload'
import { yuanToCents, centsToYuan } from '@/utils/amount'
import { MemberApi } from '@/api/member/member'

export default {
  name: 'ManageAccountAdjustTab',
  props: {
    resetKey: {
      type: Number,
      default: 0,
    },
    uid: {
      type: [Number, String],
      default: null,
    },
    memberInfo: {
      type: Object,
      default: () => ({}),
    },
    targetInfo: {
      type: Object,
      default: () => ({}),
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        change_type: 1,
        adjust_method: 'up',
        gold_yuan: null,
        desc: '',
        image_url: '',
        need_lock: 2,
        multiple: 1,
      },
      rules: {
        change_type: [{ required: true, message: '请选择调整类型', trigger: 'change' }],
        gold_yuan: [
          { required: true, message: '请输入调整金额', trigger: 'blur' },
          { type: 'number', min: 0.01, message: '调整金额必须大于0', trigger: 'blur' },
        ],
        desc: [{ required: true, message: '请输入备注', trigger: 'blur' }],
        // image_url: [{ required: true, message: '请上传图片', trigger: 'change' }],
        need_lock: [{ required: true, message: '请选择打码限制', trigger: 'change' }],
        multiple: [{ type: 'number', min: 1, message: '打码倍数必须为正整数', trigger: 'blur' }],
      },
      walletBalance: null,
      balanceLoading: false,
      submitLoading: false,
    }
  },
  computed: {
    memberAccount() {
      return this.targetInfo?.username || this.uid || '--'
    },
    walletBalanceDisplay() {
      if (this.walletBalance == null) return '--'
      return centsToYuan(this.walletBalance).toLocaleString('zh-CN', { minimumFractionDigits: 2 })
    },
  },
  watch: {
    resetKey() {
      this.resetForm()
      this.walletBalance = null
      this.balanceLoading = false
      this.submitLoading = false
    },
    'form.adjust_method'(val) {
      if (val === 'down') {
        this.form.need_lock = 2
        this.form.multiple = 0
      }
    },
    memberInfo: {
      handler(val) {
        if (val && (val.account_info?.gold != null || val.gold != null)) {
          this.walletBalance = val.account_info?.gold ?? val.gold
        }
      },
      immediate: true,
      deep: true,
    },
    isActive: {
      handler(val) {
        if (val && this.uid) this.refreshWalletBalance()
      },
      immediate: true,
    },
  },
  methods: {
    /** TODO: 刷新钱包余额 - 需对接获取余额接口 */
    async refreshWalletBalance() {
      this.balanceLoading = true
      try {
        // TODO: 调用获取会员余额接口，更新 this.walletBalance
        const response = await MemberApi.getPlayerGold(this.uid)
        const data = response?.data || {}
        const gold = data?.account_info?.gold ?? data?.gold ?? data?.base_info?.gold
        if (gold != null) {
          this.walletBalance = gold
          // this.$message.success('余额已刷新')
        } else {
          // this.$message.warning('暂无法获取余额')
        }
      } catch (e) {
        this.$message.error('刷新余额失败')
        console.error(e)
      } finally {
        this.balanceLoading = false
      }
    },
    async handleImageChange(file) {
      try {
        const result = await uploadToS3(file.raw)
        if (result.success) {
          this.form.image_url = result.data.objectUrl
          this.$message.success('图片上传成功')
        } else {
          this.$message.error('图片上传失败：' + (result.error || ''))
        }
      } catch (e) {
        this.$message.error('图片上传失败')
        console.error(e)
      }
    },
    beforeUpload(file) {
      const isImg = /\.(jpg|jpeg|png)$/i.test(file.name)
      if (!isImg) {
        this.$message.error('只能上传 JPG、JPEG、PNG 格式')
        return false
      }
      if (file.size > 5 * 1024 * 1024) {
        this.$message.error('图片大小不超过 5M')
        return false
      }
      return true
    },
    handleSubmit() {
      if (this.form.need_lock === 1 && (!this.form.multiple || this.form.multiple < 1)) {
        this.$message.warning('请选择打码限制或输入打码倍数')
        return
      }
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.submitLoading = true
        try {
          const goldCents = yuanToCents(this.form.gold_yuan)
          const gold = this.form.adjust_method === 'down' ? -goldCents : goldCents
          const isUp = this.form.adjust_method === 'up'
          const params = {
            uid: Number(this.uid),
            change_type: this.form.change_type,
            gold,
            desc: this.form.desc,
            image_url: this.form.image_url,
            need_lock: isUp ? this.form.need_lock : 2,
            multiple: isUp && this.form.need_lock === 1 ? Number(this.form.multiple) : 1,
          }
          const res = await setAccountAdjust(params)
          if (res.code === 0) {
            this.$message.success('提交成功')
            this.resetForm()
            this.$emit('success')
          } else {
            this.$message.error(res.msg || '提交失败')
          }
        } catch (e) {
          this.$message.error('提交失败')
          console.error(e)
        } finally {
          this.submitLoading = false
        }
      })
    },
    resetForm() {
      this.form = {
        change_type: 1,
        adjust_method: 'up',
        gold_yuan: null,
        desc: '',
        image_url: '',
        need_lock: 2,
        multiple: 1,
      }
      this.$refs.formRef?.resetFields()
    },
  },
}
</script>

<style lang="scss" scoped>
.account-adjust-container {
  padding: 0;
}

.input-small {
  width: 200px;
}

.textarea-small {
  width: 320px;
}

.wallet-balance-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.wallet-balance-row .el-input {
  width: 200px;
}

.form-tip {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}

.upload-placeholder,
.upload-preview {
  width: 80px;
  height: 80px;
}

.upload-placeholder {
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #8c939d;

  .el-icon-plus {
    font-size: 20px;
  }
  span {
    font-size: 12px;
    margin-top: 2px;
  }
}

.upload-tip {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
}

.suffix {
  margin-left: 6px;
  font-size: 12px;
  color: #606266;
}
</style>
